// @ts-check

import React, { useCallback, useRef } from "react"
import categoryFilterTemplate from "../../components/compounds/registeredTasksTable/CategoryFilterTemplate.compound"
import moduleFilterTemplate from "../../components/compounds/registeredTasksTable/ModuleFilterTemplate.compound"
import clientFilterTemplate from "../../components/compounds/registeredTasksTable/ClientFilterTemplate.compound"
import InputTextForm from "../../components/molecules/InputTextForm.molecule"

const EMPTY_FILTER_CONFIG = {}

/** @param {import("./useTaskReportsCommonFilters.factory.types").UseTaskReportsCommonFiltersParams} params */
export function useTaskReportsCommonFilters(params) {
  const { categories, modules, projects, loading } = params

  // TODO: Estos refs son requeridos por la implementación de PrimeReact.
  // Una vez que se migren todas las tablas a Tanstack, se deberían eliminar.
  /** @type {React.MutableRefObject<* | null>} */
  const categoryFilterOptionsRef = useRef(null)
  /** @type {React.MutableRefObject<* | null>} */
  const moduleFilterOptionsRef = useRef(null)
  /** @type {React.MutableRefObject<* | null>} */
  const clientFilterOptionsRef = useRef(null)

  const wrappedCategoryFilterTemplate = useCallback(
    /** @param {import("../../components/table/types/table").FilterElementOptions} options */
    (options) => {
      return categoryFilterTemplate({
        options,
        categories,
        filterConfig: EMPTY_FILTER_CONFIG,
        categoryFilterOptionsRef,
        loading,
      })
    },
    [categories, loading]
  )

  const wrappedModuleFilterTemplate = useCallback(
    /** @param {import("../../components/table/types/table").FilterElementOptions} options */
    (options) => {
      return moduleFilterTemplate({
        options,
        modules,
        filterConfig: EMPTY_FILTER_CONFIG,
        moduleFilterOptionsRef,
        loading,
      })
    },
    [modules, loading]
  )

  const wrappedClientFilterTemplate = useCallback(
    /** @param {import("../../components/table/types/table").FilterElementOptions} options */
    (options) => {
      return clientFilterTemplate({
        options,
        projects,
        clientFilterOptionsRef,
        loading,
      })
    },
    [projects, loading]
  )

  const taskNameFilterTemplate = useCallback(
    /** @param {import("../../components/table/types/table").FilterElementOptions} options */
    (options) => {
      return (
        <InputTextForm
          value={options.value || ""}
          onChange={(e) => options.filterCallback(e.target.value)}
          onBlur={(e) => options.filterCallback(e.target.value?.trim())}
          autoTrim={false}
          placeholder="Buscar tarea"
        />
      )
    },
    []
  )

  return {
    categoryFilterTemplate: wrappedCategoryFilterTemplate,
    moduleFilterTemplate: wrappedModuleFilterTemplate,
    clientFilterTemplate: wrappedClientFilterTemplate,
    taskNameFilterTemplate,
  }
}
